import React from 'react';
import { Pressable } from 'react-native';
import { Feather } from '@expo/vector-icons';

import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { useTheme } from '../../theme';
import { createLeadDetailStyles } from './LeadDetailView.styles';

// Inline link-style action ("Edit contact", phone, email) with a 44 pt touch area.
const LeadTextAction = ({ label, icon, onPress, disabled = false }) => {
	const styles = useThemedStyles(createLeadDetailStyles);
	const { theme: { ui: { colors } } } = useTheme();

	return (
		<Pressable
			style={({ pressed }) => [styles.textAction, pressed && styles.pressed]}
			onPress={onPress}
			disabled={disabled}
			accessibilityRole="button"
			accessibilityLabel={label}
			accessibilityState={{ disabled }}
		>
			{Boolean(icon) && <Feather name={icon} size={18} color={colors.accent} />}
			<Text style={styles.textActionLabel}>{label}</Text>
		</Pressable>
	);
};

export default LeadTextAction;
